// GENERATED FILE - DO NOT MODIFY

export enum GetBookingsSortColumnDto {
    Date = "Date",
    VenueName = "VenueName",
    ConsumerName = "ConsumerName",
    Price = "Price",
}